import Select, { type SelectOption } from '@rio-cloud/rio-uikit/Select';
import { FormattedMessage } from 'react-intl';

const locale = {
    Bulgarian: 'bg-BG',
    Czech: 'cs-CZ',
    Danish: 'da-DK',
    German: 'de-DE',
    Greek: 'el-GR',
    English: 'en-GB',
    Spanish: 'es-ES',
    Estonian: 'et-EE',
    Finnish: 'fi-FI',
    French: 'fr-FR',
    Croatian: 'hr-HR',
    Hungarian: 'hu-HU',
    Italian: 'it-IT',
    Lithuanian: 'lt-LT',
    Latvian: 'lv-LV',
    Norwegian: 'nb-NO',
    Dutch: 'nl-NL',
    Polish: 'pl-PL',
    Brazilian: 'pt-BR',
    Portuguese: 'pt-PT',
    Romanian: 'ro-RO',
    Slovak: 'sk-SK',
    Slovenian: 'sl-SI',
    Swedish: 'sv-SE',
} as const;

export type Locale = (typeof locale)[keyof typeof locale];

export const languageOptions: (SelectOption & { id: Locale; nativeLabel: string })[] = [
    { id: locale.Bulgarian, label: `🇧🇬 Bulgarian (${locale.Bulgarian})`, nativeLabel: 'български' },
    { id: locale.Czech, label: `🇨🇿 Czech (${locale.Czech})`, nativeLabel: 'Čeština' },
    { id: locale.Danish, label: `🇩🇰 Danish (${locale.Danish})`, nativeLabel: 'Dansk' },
    { id: locale.German, label: `🇩🇪 German (${locale.German})`, nativeLabel: 'Deutsch' },
    { id: locale.Greek, label: `🇬🇷 Greek (${locale.Greek})`, nativeLabel: 'Ελληνικά' },
    { id: locale.English, label: `🇬🇧 English (${locale.English})`, nativeLabel: 'English', selected: true },
    { id: locale.Spanish, label: `🇪🇸 Spanish (${locale.Spanish})`, nativeLabel: 'Español' },
    { id: locale.Estonian, label: `🇪🇪 Estonian (${locale.Estonian})`, nativeLabel: 'Eesti' },
    { id: locale.Finnish, label: `🇫🇮 Finnish (${locale.Finnish})`, nativeLabel: 'Suomalainen' },
    { id: locale.French, label: `🇫🇷 French (${locale.French})`, nativeLabel: 'Français' },
    { id: locale.Croatian, label: `🇭🇷 Croatian (${locale.Croatian})`, nativeLabel: 'Hrvatski' },
    { id: locale.Hungarian, label: `🇭🇺 Hungarian (${locale.Hungarian})`, nativeLabel: 'Magyar' },
    { id: locale.Italian, label: `🇮🇹 Italian (${locale.Italian}) 🤌`, nativeLabel: 'Italiano' },
    { id: locale.Lithuanian, label: `🇱🇹 Lithuanian (${locale.Lithuanian})`, nativeLabel: 'Lietuvių' },
    { id: locale.Latvian, label: `🇱🇻 Latvian (${locale.Latvian})`, nativeLabel: 'Latviešu' },
    { id: locale.Norwegian, label: `🇳🇴 Norwegian (${locale.Norwegian})`, nativeLabel: 'Bokmål' },
    { id: locale.Dutch, label: `🇳🇱 Dutch (${locale.Dutch})`, nativeLabel: 'Nederlands' },
    { id: locale.Brazilian, label: `🇧🇷 Brazilian (${locale.Brazilian})`, nativeLabel: 'Português (Brasil)' },
    { id: locale.Portuguese, label: `🇵🇹 Portuguese (${locale.Portuguese})`, nativeLabel: 'Português (Portugal)' },
    { id: locale.Romanian, label: `🇷🇴 Romanian (${locale.Romanian})`, nativeLabel: 'Română' },
    { id: locale.Slovak, label: `🇸🇰 Slovak (${locale.Slovak})`, nativeLabel: 'Slovenčina' },
    { id: locale.Slovenian, label: `🇸🇮 Slovenian (${locale.Slovenian})`, nativeLabel: 'Slovenščina' },
    { id: locale.Swedish, label: `🇸🇪 Swedish (${locale.Swedish})`, nativeLabel: 'Svenska' },
    { id: locale.Polish, label: `🇵🇱 Polish (${locale.Polish})`, nativeLabel: 'Polski' },
];

interface Props {
    handleLocaleChange: (locale: Locale) => void;
}

export const LanguageSelect = (props: Props) => {
    const { handleLocaleChange } = props;

    return (
        <div className='col-12 col-sm-4 form-group'>
            <label htmlFor='language-select'>
                <FormattedMessage id={'helpgang.addFleetAdminDialog.language'} />
            </label>
            <Select
                id='language-select'
                options={languageOptions}
                onChange={item => handleLocaleChange(item?.id ?? locale.English)}
            />
        </div>
    );
};
